module.exports = __webpack_public_path__ + "static/media/r9.58c1060f.jpg";